import { get as getEmplacement } from '@/api/gabed/emplacement/index';
import { get as getDispositif } from '@/api/gabed/dispositif/index';
import { get as getMateriel } from '@/api/gabed/materiel/index';
import { get as getFace } from '@/api/gabed/face/index';

function getLibelleAdresse(adresse) {
  let libelle = '';
  if (adresse.adresse1) libelle += adresse.adresse1;
  if (adresse.codePostal) libelle += ', ' + adresse.codePostal;
  if (adresse.ville) libelle += ' ' + adresse.ville;
  return libelle;
}

export default async function getPatrimoineOnDemandeLogistique(demandeLogistique) {
  if (!demandeLogistique) return null;
  if (demandeLogistique.emplacementId) {
    const emplacement = (await getEmplacement(demandeLogistique.emplacementId)).data.result;
    return {
      ...emplacement,
      searchPatrimoine: emplacement.code + getLibelleAdresse(emplacement.adresseCadastrale),
    };
  }
  if (demandeLogistique.dispositifId) {
    const dispositif = (await getDispositif(demandeLogistique.dispositifId)).data.result;
    return {
      ...dispositif,
      searchPatrimoine: dispositif.code + getLibelleAdresse(dispositif.adresse),
    };
  }
  if (demandeLogistique.materielId) {
    const materiel = (await getMateriel(demandeLogistique.materielId)).data.result;
    return {
      ...materiel,
      searchPatrimoine: materiel.code + getLibelleAdresse(materiel.dispositif.adresse),
    };
  }
  if (demandeLogistique.faceId) {
    const face = (await getFace(demandeLogistique.faceId)).data.result;
    return {
      ...face,
      searchPatrimoine: face.code + getLibelleAdresse(face.materiel.dispositif.adresse),
    };
  }
  return null;
}
